import React, { useEffect, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { fetch_other_project } from '@store/otherProjects.slice';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { useParams } from 'react-router-dom';
import WorkPage from '@components/WorkPage';

const Projects = () => {
  const { other_project, is_fetching_other_project } = useSelector(
    (state) => state.other_projects,
  );
  const dispatch = useDispatch();

  const { other_projects_slug } = useParams();
  useEffect(() => {
    if (
      Object.keys(other_project).length === 0 &&
      other_project.constructor === Object
    ) {
      fetch();
    }
  }, [other_projects_slug]);

  const fetch = async () => {
    await dispatch(fetch_other_project(other_projects_slug));
  };

  const OtherProjectComponent = useMemo(() => {
    if (
      !(
        Object.keys(other_project).length === 0 &&
        other_project.constructor === Object
      )
    ) {
      return (
        <WorkPage
          images={other_project.photo_gallery.images[0].concat(
            other_project.videos || [],
          )}
          text={other_project}
        />
      );
    } else {
      return <> </>;
    }
  }, [other_project]);

  return <>{OtherProjectComponent}</>;
};

export default Projects;
